import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import * as S from './../../pages/ReviewPage/ReviewPage.styles';
import Icon from './../../../stories/core-components/IconsSelector';
const ThankyouFailed = props => {
const {isError} = props;
    const {txnid} = props.thankyouInfo;
    if(isError){
        return (
            <>
    
    <div className="thkContHdr tu_error marginB20" id="failedpayment">
                             <div className="col-md-12 col-sm-12 row">
                                 <div className="fl greyLter ico50 marginT20 padLR20 marginLR20 mobdn">
                                     <span className="fl">:</span>
                                     <span className="fl">-</span>
                                     <span className="fl">(</span>
                                 </div>
                                 <div className="thkContHdrTxt">
                                    <h3 className="blue lh1-5 headSet">Oops! Something Went wrong.</h3>
                                     <p className="ico14  lh1-5">{`There was a problem processing your payment.`}
                                       
                                     </p>
                                    <p className="ico14  lh1-5">
                                        {`In case of any issues, you can contact our `}
                                        <a href='/support'>customer care team</a>.
                                        {`for any communication related to this payment failure.`}
                                    </p>
                              
                                 </div>
                             </div>
                         </div>
            </>
        )
    }
    
    return (
        <>

<div className="thkContHdr tu_error marginB20" id="failedpayment">
                         <div className="col-md-12 col-sm-12 row">
                             <div className="fl greyLter ico50 marginT20 padLR20 marginLR20 mobdn">
                                 <span className="fl">:</span>
                                 <span className="fl">-</span>
                                 <span className="fl">(</span>
                             </div>
                             <div className="thkContHdrTxt">
                                <h3 className="blue lh1-5 headSet">Oops! Your payment failed.</h3>
                                 <p className="ico14  lh1-5">{`There was a problem processing your payment.`}
                                   
                                 </p>
                                <p className="ico14  lh1-5">
                                    {`In case of any issues, you can contact our `}
                                    <a href='/support'>customer care team</a>.
                                    {` Please note your goibibo reference ID`}
                                    <strong> {txnid} </strong>
                                    {`for any communication related to this payment failure.`}
                                </p>
                          
                             </div>
                         </div>
                     </div>
        </>
    )
}
export default ThankyouFailed;